import { get, put, post } from "./apiHelper";
import {
  GetUserResponse,
  CheckMeetingResponse,
  UpdateDurationResponse,
  StartMeetingResponse,
  EndMeetingResponse,
  ParticipantJoinedResponse,
  ParticipantLeftResponse,
} from "~/types/backend";

// User

export const getAuthUser = () => get<GetUserResponse>('/me');

// Meeting

export const checkMeeting = (uuid: string) => get<CheckMeetingResponse>(`/meeting/${uuid}`);

export const updateDuration = (id: number) => put<UpdateDurationResponse>(`/meeting/${id}/update-duration`);

export const startMeeting = (id: number) => put<StartMeetingResponse>(`/meeting/${id}/start`);

export const endMeeting = (id: number) => put<EndMeetingResponse>(`/meeting/${id}/end`);

export const participantJoined = (id: number, participantName: string) =>
  post<ParticipantJoinedResponse>(`/meeting/${id}/participant-joined`, { participantName });

export const participantLeft = (id: number, participantName: string) =>
  post<ParticipantLeftResponse>(`/meeting/${id}/participant-left`, { participantName });
